export const messageConstants = {
  EMAIL_MISSING: "Please enter email",
  PASSWORD_MISSING: "Please enter password",
  CONFIRM_PASSWORD_MISSING: "Please enter confirm password",
  PASSWORD_NOT_MATCH: "Passwords does not match",
  FILE_NOT_ACCEPTABLE: "Only dra files are acceptable",
  FILE_NOT_FOUND: "File not found",
  FILE_INVALID_CODE: "file-invalid-type",
};
